(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volcanic-product-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vp-hero').forEach(function(section){
    var bottle=section.querySelector('.vp-hero__bottle');
    section.querySelectorAll('.vp-hero__thumbs button').forEach(function(button){
      button.addEventListener('click',function(){
        section.querySelectorAll('.vp-hero__thumbs button').forEach(function(item){item.classList.remove('is-active')});
        button.classList.add('is-active');
        if(bottle) bottle.src=button.dataset.image;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
